import { EditToolBox } from '@carboncopyco/components';
import { PlusOutlineIcon } from '@carboncopyco/icons';
import { Button, Checkbox, ColorHex, TextCaption } from '@carboncopyco/ui';
import useImageProps from '../../../../../hooks/useImageProps';

type EditToolImagePickerTypes = {
  image: string;
  onImageChange: (image: string) => void;
  isImageBlurred: boolean;
  setIsImageBlurred: (isBlurred: boolean) => void;
};
export const ImagePicker = ({
  image,
  onImageChange,
  isImageBlurred,
  setIsImageBlurred,
}: EditToolImagePickerTypes) => {
  const { getInputProps, getRootProps, open } = useImageProps({
    onImageAdded: onImageChange,
  });

  const ImagePlaceholder = () => {
    return (
      <div className="w-20 h-14 grid grid-cols-6 grid-rows-4 border border-ds-natural-150 rounded-md overflow-hidden">
        {[...Array(4)].map((_row, rowIndex) =>
          [...Array(6)].map((_col, colIndex) => (
            <div
              key={`${rowIndex}-${colIndex}`}
              className={`${(rowIndex + colIndex) % 2 === 0 ? 'bg-white' : 'bg-ds-natural-150'}`}
            />
          ))
        )}
      </div>
    );
  };

  const renderAddImageButton = () => {
    return (
      <div {...getRootProps()}>
        <div className="w-20">
          <Button
            onClick={open}
            icon={<PlusOutlineIcon color={ColorHex.primary} />}
            link
            xSmall
          >
            <TextCaption
              label="Upload"
              color="text-ds-primary"
            />
          </Button>
          <input {...getInputProps()} />
        </div>
      </div>
    );
  };

  return (
    <EditToolBox>
      <div className="flex flex-row mb-3">
        {image ? (
          <div className="w-20 h-14 border border-ds-natural-150 rounded-md overflow-hidden">
            <img
              src={image}
              alt="edit-tool-image-picker-picked-image"
              className="w-full h-full"
            />
          </div>
        ) : (
          <ImagePlaceholder />
        )}
        <div className="flex flex-col justify-center pl-2 pb-1">
          <TextCaption label="Supported formats: JPEG, PNG" />
          <TextCaption label="Minimum size: 100 x 100 pixels" />
          {renderAddImageButton()}
        </div>
      </div>
      {image && (
        <Checkbox
          name="blurImage"
          label={
            <TextCaption
              label="Blur image"
              color="text-ds-natural-600"
            />
          }
          checked={isImageBlurred}
          onChange={() => {
            setIsImageBlurred(!isImageBlurred);
          }}
        />
      )}
    </EditToolBox>
  );
};
